module.exports = __webpack_public_path__ + "img/delete_black_24dp.ee46ca53.svg";